import React, { useState } from "react"
import { Button, Alert } from "reactstrap"
import { useLoading } from "helpers/custom_hooks"
import { UpdateCPSRequest } from "helpers/backend_helper"
import { displayMessage } from "helpers/misc_helpers"
import moment from "moment"

const CPSAcceptOffer = ({ entry, myUser, statusIndex, reload }) => {
  const setLoading = useLoading()
  const [isProcessing, setIsProcessing] = useState(false)

  // Determine if this step is active
  const isActive = entry?.statusIndex === 2 || entry?.statusIndex === 3
  const isCompleted = entry?.statusIndex > 3

  // Check if user is the customer (can accept/decline offers)
  const isCustomer = myUser?.company?.id === entry?.requestorCompanyID
  const canDecide = isActive && !isCompleted && isCustomer

  const handleAcceptOffer = async () => {
    setIsProcessing(true)
    setLoading(true)
    try {
      // For subrequests, skip the "Goods Shipped" (4) and "Goods Received" (5) steps, go directly to status 6
      const isSubRequest = entry?.parentRequestNumber || entry?.parentID
      const nextStatusIndex = isSubRequest ? 6 : 4
      
      const updatedEntry = {
        ...entry,
        dateOfferAccepted: new Date().toISOString(),
        statusIndex: nextStatusIndex, // Move to next status (skip Goods Shipped & Goods Received for subrequests)
      }

      await UpdateCPSRequest(updatedEntry)

      // Small delay to ensure backend has processed the update
      setTimeout(() => {
        reload()
      }, 500)
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }
    setIsProcessing(false)
    setLoading(false)
  }

  const handleDeclineOffer = async () => {
    setIsProcessing(true)
    setLoading(true)
    try {
      const updatedEntry = {
        ...entry,
        dateOfferDeclined: new Date().toISOString(),
        statusIndex: 6, // Move to Cancelled status
      }

      await UpdateCPSRequest(updatedEntry)

      // Small delay to ensure backend has processed the update
      setTimeout(() => {
        reload()
      }, 500)
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }
    setIsProcessing(false)
    setLoading(false)
  }

  const getAcceptedDate = () => {
    if (entry?.dateOfferAccepted) {
      return moment(entry.dateOfferAccepted).format("DD.MM.YYYY")
    }
    return null
  }

  return (
    <li className={"event-list " + (isActive ? "active" : "")}>
      <div
        className={"event-timeline-dot " + (isActive ? "bx-fade-right" : "")}
      >
        <i className="bx bx-right-arrow-circle font-size-18"></i>
      </div>
      <div className="d-flex">
        <div className="flex-shrink-0 me-3">
          <h5 className="font-size-14">
            {isCompleted ? getAcceptedDate() : ""}{" "}
            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
          </h5>
        </div>
        <div className="flex-grow-1">
          <div>
            Customer Decision{" "}
            {isActive
              ? " - waiting for customer decision"
              : isCompleted
              ? " - offer accepted by customer"
              : ""}
          </div>
        </div>
      </div>

      {isCompleted && entry?.dateOfferAccepted && (
        <div className="d-flex align-items-center mt-3">
          <div style={{ width: "45px" }}>
            <div className="avatar-sm">
              <span className="avatar-title rounded-circle bg-success bg-soft text-success font-size-24">
                <i className="bx bx-check" />
              </span>
            </div>
          </div>
          <div className="ms-4">
            <h5 className="font-size-14 mb-1">Offer Accepted</h5>
            <small>Accepted on {getAcceptedDate()}</small>
          </div>
        </div>
      )}

      {canDecide && (
        <div className="mt-3">
          <Alert color="info">
            <i className="bx bx-info-circle me-2"></i>
            Please review the CPS offer and make your decision.
          </Alert>
          <div className="d-flex gap-2">
            <Button
              color="success"
              size="sm"
              onClick={handleAcceptOffer}
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Accept Offer"}
            </Button>
            <Button
              color="danger"
              size="sm"
              onClick={handleDeclineOffer}
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Decline Offer"}
            </Button>
          </div>
        </div>
      )}
    </li>
  )
}

export default CPSAcceptOffer
